module.exports = __webpack_public_path__ + "img/OrangeLightAnimationv2.4c662519.gif";